import Pt from 'prop-types'
import { connect } from 'react-redux'
import Select from 'react-select'

import {
  makeSelectClient,
  makeSelectClientSearch,
} from 'internal-components/src/redux/modules/client'
import { makeSelectLoading } from 'internal-components/src/redux/modules/loading'

export const makeMapStateToProps = () => {
  const selectClientSearch = makeSelectClientSearch()
  const selectLoading = makeSelectLoading()
  const selectClient = makeSelectClient()

  return (state, ownProps) => ({
    isLoading: selectLoading(state, { type: 'clients' }),
    options: selectClientSearch(state, {
      query: ownProps.query,
      selected: ownProps.value,
    }).toArray(),
    value: selectClient(state, { clientId: ownProps.value }),
  })
}

const WrappedMspClientSelector = connect(makeMapStateToProps)(Select)

WrappedMspClientSelector.propTypes = {
  query: Pt.string,
}

export default WrappedMspClientSelector



// WEBPACK FOOTER //
// ./src/components/Signup/MspClientSelector/SearchingSelector.jsx